import { FilterGroupName } from '../constants'
import { Filters } from '../../../../src/store/models/SearchModels'

export const STORAGE_APPLIED_FILTERS_KEY = 'search-applied-filters'

export interface PersistedAppliedFilters {
  filters: Filters
  selectedLinesManufacturers: string[]
  firstSelectedFilterType?: FilterGroupName
}

/**
 * Saves the currently applied results filters so they survive a page refresh.
 */
export const persistAppliedFilters = (state: PersistedAppliedFilters): void => {
  try {
    sessionStorage.setItem(STORAGE_APPLIED_FILTERS_KEY, JSON.stringify(state))
  } catch {
    // sessionStorage may be unavailable (private mode quota, etc.)
  }
}

/**
 * Clears persisted applied filters (new search or clear-all).
 */
export const clearPersistedAppliedFilters = (): void => {
  try {
    sessionStorage.removeItem(STORAGE_APPLIED_FILTERS_KEY)
  } catch {
    // ignore
  }
}

/**
 * Reads persisted applied filters from the previous session, if any.
 */
export const readPersistedAppliedFilters = ():
  | PersistedAppliedFilters
  | undefined => {
  try {
    const raw = sessionStorage.getItem(STORAGE_APPLIED_FILTERS_KEY)
    if (!raw) return undefined
    const parsed = JSON.parse(raw) as PersistedAppliedFilters
    if (!Array.isArray(parsed?.filters)) return undefined
    return parsed
  } catch {
    return undefined
  }
}
